/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Tr_8_QInputs */

const en_tut_tr_8_q = /** @type {(inputs: Tut_Tr_8_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nobody hears me on nearby audio.`)
};

const id_tut_tr_8_q = /** @type {(inputs: Tut_Tr_8_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekan tidak mendengar saya di audio sekitar.`)
};

/**
* | output |
* | --- |
* | "Nobody hears me on nearby audio." |
*
* @param {Tut_Tr_8_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_tr_8_q = /** @type {((inputs?: Tut_Tr_8_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Tr_8_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_tr_8_q(inputs)
	return en_tut_tr_8_q(inputs)
});